module.exports = __webpack_public_path__ + "static/img/document-preview-1.6153aaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/file-manager/document-preview-1.jpg
// module id = BucY
// module chunks = 3